import { MDBDataTable } from "mdbreact";
import React, { useEffect, useMemo, useState } from "react";
import { MutatingDots } from "react-loader-spinner";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Bounce, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  Button,
  Card, CardBody, CardTitle,
  Col,
  Row
} from "reactstrap";
import api from "../../services/api";
import { setBreadcrumbItems } from "../../store/actions";
import "./mdb-table-custom.css";

const CourseProgramNamesList = (props) => {
  const navigate = useNavigate();
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const [courseProgramNames, setCourseProgramNames] = useState([]);
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedTerm, setSelectedTerm] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);
  const [loading, setLoading] = useState(true);

  const breadcrumbItems = [
    { title: "Technical Hub", link: "#" },
    { title: "Course Discounts", link: "#" },
    { title: "Course Discounts List", link: "#" },
  ];

  useEffect(() => {
    const getCourseProgramNames = async () => {
      try {
        const response = await api.get(`${backendUrl}get-all-course-program-names`);
        if (response.status === 200) {
          console.log("Fetched Course Program Names:", response.data.result);
          setCourseProgramNames(response.data.data);
        }
      } catch (err) {
        toast.error("Failed to fetch discounts");
      } finally {
        setLoading(false);
      }
    };
    getCourseProgramNames();
    props.setBreadcrumbItems("Course Program Names", breadcrumbItems);
  }, []);

  const toggleModal = () => setModalOpen(!modalOpen);
  const toggleDeleteModal = () => setDeleteModalOpen(!deleteModalOpen);

  const handleEdit = (id) => {
    console.log("Selected Program name:", id);
    navigate(`/edit-course-program-name/${id}`)
  };



  const data = useMemo(
    () => ({
      columns: [
        { label: "S.No", field: "sno", sort: "asc", width: 50 },
        // Add other columns as needed
        { label: "Program", field: "program_name", sort: "asc", width: 150 },
        { label: "Course", field: "course_name", sort: "asc", width: 100 },
        { label: "Passout_year", field: "passout_year", sort: "asc", width: 100 },
        { label: "Actions", field: "actions", sort: "asc", width: 100 },
      ],
      rows: courseProgramNames.map((program_name) => ({
        sno: courseProgramNames.indexOf(program_name) + 1,
        program_name: program_name.program_name,
        course_name: program_name.course_name,
        passout_year: program_name.passout_year,
        // remarks: discount.remarks,
        actions: (
          <Button
            color="primary"
            size="sm"
            onClick={() => handleEdit(program_name._id)}
          >
            Edit
          </Button>
        ),
      })),
    }),
    [courseProgramNames]
  );

  return (
    <React.Fragment>
      <Row>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          transition={Bounce}
        />
        <Col className="col-12">
          <Card>
            <CardBody className="d-flex justify-content-between align-items-center">
              <CardTitle className="h4">Course Program Names List</CardTitle>
              <Button color="primary" tag="a" href="/add-course-program-name">
                Add Program Name
              </Button>
            </CardBody>
            <CardBody>
              {loading ? (
                <div
                  className="d-flex justify-content-center align-items-center"
                  style={{ minHeight: "300px" }}
                >
                  <MutatingDots
                    visible
                    height="100"
                    width="100"
                    color="#2B3A4A"
                    secondaryColor="#2B3A4A"
                    radius="12.5"
                    ariaLabel="mutating-dots-loading"
                  />
                </div>
              ) : (
                <MDBDataTable responsive bordered data={data} />
              )}

            </CardBody>
          </Card>
        </Col>
      </Row>



    </React.Fragment>
  );
};

export default connect(null, { setBreadcrumbItems })(CourseProgramNamesList);
